import DocumentHistoryDialog from './DocumentHistoryDialog';

export default { 
  name: "documentHistory", 
  component: DocumentHistoryDialog, 
  fullScreen: false
};